import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { chatSubsActions } from "../../../di/di";

export const ChatSubsUIAction = Object.freeze({
  initial: "Initial",
  showErrorToast: "showErrorToast",
  performSubscribing: "performSubscribing",
  addPaymentMethodSuccess: "addPaymentMethodSuccess",
  addBillingAddressSuccess: "addBillingAddressSuccess",
});

export const SubscribeStatus = Object.freeze({
  initial: "initial",
  ongoing: "ongoing",
  success: "success",
  failed: "failed",
});

const initialState = {
  action: ChatSubsUIAction.initial,
  message: "",
  subscribeStatus: SubscribeStatus.initial,
};

export const createChatSubsSlice = (tierRepository) => {
  return createSlice({
    name: "chatSubs",
    initialState,
    reducers: {
      resetState: () => initialState,
      setAction: (state, action) => {
        state.action = action.payload;
      },
      setMessage: (state, action) => {
        state.message = action.payload;
      },
    },
    extraReducers: (builder) => {},
  });
};
